import React from 'react';
import { SidebarGroup, SidebarGroupLabel, SidebarGroupContent } from '@/components/ui/sidebar';
import { SidebarNavItem } from './SidebarNavItem';
import { SubscriptionAwareSidebarItem } from './SubscriptionAwareSidebar';
import { NavItem, toolsSubgroups } from './SidebarData';
import { Smartphone, DatabaseIcon, HomeIcon, FileTextIcon, ShieldIcon } from 'lucide-react';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { CollapsibleToolsGroup } from './CollapsibleToolsGroup';

interface SidebarNavGroupProps {
  category: string;
  label: string;
  items: NavItem[];
}

export const SidebarNavGroup: React.FC<SidebarNavGroupProps> = ({
  category,
  label,
  items
}) => {
  const { hasRole } = useAuth();
  const isMobileSuite = category === 'mobile_suite';
  const isAdmin = category === 'admin';
  
  // Hide admin section from non-admin/owner users
  if (isAdmin && !hasRole(['admin', 'owner'])) {
    return null;
  }

  // Special rendering for tools category with collapsible subgroups
  if (category === 'tools') {
    const dataToolItems = items.filter(item => toolsSubgroups.data_tools.paths.includes(item.path));
    const propertyToolItems = items.filter(item => toolsSubgroups.property_tools.paths.includes(item.path));
    const reportItems = items.filter(item => toolsSubgroups.reports.paths.includes(item.path));

    return (
      <SidebarGroup>
        <SidebarGroupLabel>{label}</SidebarGroupLabel>
        <SidebarGroupContent>
          <div className="space-y-2">
            <CollapsibleToolsGroup
              label={toolsSubgroups.data_tools.label}
              icon={DatabaseIcon}
              items={dataToolItems}
              defaultOpen={true}
            />
            <CollapsibleToolsGroup
              label={toolsSubgroups.property_tools.label}
              icon={HomeIcon}
              items={propertyToolItems}
            />
            <CollapsibleToolsGroup
              label={toolsSubgroups.reports.label}
              icon={FileTextIcon}
              items={reportItems}
            />
          </div>
        </SidebarGroupContent>
      </SidebarGroup>
    );
  }
  
  return (
    <SidebarGroup>
      <SidebarGroupLabel className="flex items-center gap-2">
        {isMobileSuite && <Smartphone className="h-4 w-4 text-cyan-500" />}
        {isAdmin && <ShieldIcon className="h-4 w-4 text-amber-500" />}
        {label}
      </SidebarGroupLabel>
      <SidebarGroupContent>
        <div className="space-y-1">
          {items.map((item) => (
            <SubscriptionAwareSidebarItem
              key={item.path}
              item={item}
              isActive={false}
              onClick={() => {}}
            >
              <SidebarNavItem item={item} />
            </SubscriptionAwareSidebarItem>
          ))}
        </div>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
